import React, { useState, useEffect } from 'react';
import './Navigation.css';
import {UserOutlined, FileDoneOutlined, SignatureOutlined, DownloadOutlined, HistoryOutlined} from '@ant-design/icons';
import { Menu } from 'antd';
import { Link, useLocation } from "react-router-dom";
import type { MenuProps } from 'antd';
import './Navigation.css';

const items: MenuProps['items'] = [
    {
        label: (
            <Link to="/" rel="Sign in page">
                {'SIGN IN       '}
            </Link>
        ),
        key: '',
        icon: <UserOutlined />,
    },
    {
        label: (
            <Link to="/ddr-2-approve" rel="DDR to approve page">
                {'DDR TO APPROVE'}
            </Link>
        ),
        key: 'ddr-2-approve',
        icon: <SignatureOutlined />,
    },
    {
        label: (
            <Link to="/view-ddr"  rel="View DDR page">
                {'NEW DDR       '}
            </Link>
        ),
        key: 'view-ddr',
        icon: <FileDoneOutlined />,
    },
    {
        label: (
            <Link to="/submitted-ddr"  rel="Submittd DDR page">
                {'SUBMITTED DDR '}
            </Link>
        ),
        key: 'submitted-ddr',
        icon: <HistoryOutlined />,
    },
    {
        label: (
            <Link to="/get-the-app"  rel="Get the app page">
                {'GET THE APP   '}
            </Link>
        ),
        key: 'get-the-app',
        icon: <DownloadOutlined />,
    },
];

const Navigation = () => {
    const location = useLocation();
    const currentPage = location.pathname.replace('/', '');
    const [current, setCurrent] = useState<string>(currentPage);

   useEffect(() => {
       const currentPage = location.pathname.replace('/', '');
       setCurrent(currentPage);
    }, [location]);

    const onClick: MenuProps['onClick'] = (e) => {
        setCurrent(e.key);
    };

    return <Menu onClick={onClick} selectedKeys={[current]} mode="horizontal" items={items} />;
};

export default Navigation;